export enum Tabs {
  INFO = 'info',
  PLAY = 'play',
}
